import confetti from 'canvas-confetti';

interface CelebrateProps {
  zIndex?: number;
}

export const celebrate = ({ zIndex = 99 }: CelebrateProps = {}): void => {
  const duration = 2500;
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 80, spread: 1500, ticks: 100, zIndex, scalar: 1.5 };

  const interval = setInterval((): void => {
    const timeLeft = animationEnd - Date.now();
    if (timeLeft <= 0) {
      clearInterval(interval);
      return;
    }
    const particleCount = 20 * (timeLeft / duration);
    // since particles fall down, start a bit higher than random
    confetti({ ...defaults, particleCount, origin: { x: 0.0, y: -0.1 } });
    confetti({ ...defaults, particleCount, origin: { x: 0.35, y: -0.1 } });
    confetti({ ...defaults, particleCount, origin: { x: 0.7, y: -0.1 } });
    confetti({ ...defaults, particleCount, origin: { x: 1, y: -0.1 } });
  }, 50);
};
